import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return <div className="empty">Something went wrong. Please refresh and try again.</div>;
    }

    return this.props.children;
  }
}
